import {
  type EvidenceTypeEnum,
  getApiTradeV1SiteMaterialsEvidenceListQueryKey,
  useApiTradeV1SiteMaterialsEvidenceListSuspense,
  useQueryClient,
} from 'api';
import { ActionBar, useManageEvidence, useSiteMaterial } from 'features';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Grid, Page, PhotoEvidenceMultiSelectList, Section, Typography, useBreakpoint } from 'ui';

import { SiteHeader } from '../../components/SiteHeader/SiteHeader';

export const EvidenceEdit = ({ evidenceType }: { evidenceType: EvidenceTypeEnum }) => {
  const { isMobile } = useBreakpoint();
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const { data: siteMaterial } = useSiteMaterial();
  const { data } = useApiTradeV1SiteMaterialsEvidenceListSuspense(String(siteMaterial.id), {
    page_size: 10000,
    type: evidenceType,
  });
  const { selected, setSelected, deleteSelected, isPending } = useManageEvidence({
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: getApiTradeV1SiteMaterialsEvidenceListQueryKey(String(siteMaterial.id)),
      });
      navigate(-1);
    },
  });

  if (!data) {
    return <Typography>Material not found</Typography>;
  }

  return (
    <Page>
      <Page.Title title="Edit Evidence" />
      <Page.Divider />
      <Grid container>
        <Grid item xs={12} md={4}>
          <Section title="Site Details">
            <SiteHeader siteMaterial={siteMaterial} />
            <Box mt={2} mb={1}>
              <ActionBar
                selected={selected.length}
                handleClose={() => navigate(-1)}
                handleDelete={deleteSelected}
                actionPending={isPending}
              />
            </Box>
          </Section>
        </Grid>
        <Grid item xs={12} md={8}>
          <Section
            title="Evidence"
            action={
              <Button size="large" fullWidth variant="secondary" onClick={() => navigate(-1)} loading={isPending}>
                Cancel
              </Button>
            }
          >
            <PhotoEvidenceMultiSelectList
              slotProps={{
                imageList: {
                  cols: isMobile ? 3 : 5,
                },
              }}
              evidencePhotos={data.results.map(({ id, file, preview }) => ({
                id,
                src: (preview || file) ?? '',
              }))}
              onSelectionChange={setSelected}
            />
          </Section>
        </Grid>
      </Grid>
    </Page>
  );
};
